import { createContext, useContext, useEffect, useState } from 'react'
import { LoginOrSignUpModal } from './LoginOrSignUpModal'
import { OtpModal } from './OtpModal'
import { FooterModal } from './FooterModal'
import { postMethod } from '../utils/functions'
import { OTP_GENERATE_ENDPOINT, CONNECTION_TOAST } from '../constants/all'
import { useRouterHook } from '../hooks/useRouterHook'
import { useRouter } from 'next/router'
import Cookies from 'universal-cookie'
import { getMethod } from '../utils/functions'
import { CREAT_JOB_STATUS } from '../constants/all'
import { SharedContext } from '@/context/SharedContext'
import { SeekerContext } from '@/context/SeekerContext'

export const LoginContext = createContext()

export const LoginOrSignUp = ({ isOpen, onClose }) => {
  const [otpModalOpen, setotpModal] = useState(false)
  const [mobileNumber, setMobileNumber] = useState('')
  const router = useRouter();
  const [otp, setOtp] = useState()
  const [isChangeNumber, setChangeNumber] = useState(false)
  const cookie = new Cookies()
  const { setLoginDetails, countryCode, isOnline, setShowToast } = useContext(SharedContext)
  const { isclickedHRCTA, setIsJobProfileCreated } = useContext(SeekerContext)
  const { navigateToPagesInSeeker } = useRouterHook()
  const hirePathRegex = /^(?:\/hire|\/recruit)(?:[\/?#].*)?$/;
  const isHire = hirePathRegex.test(router?.asPath);
  const checkProfileStatus = async (isLogedIn) => {
    if (isLogedIn && !isHire) {
      const user = await cookie.get('user')
      if (user) {
        const res = await getMethod({
          url: process?.env?.NEXT_PUBLIC_BASE_URL_ADS + CREAT_JOB_STATUS + `${user}/status/`,
          headers: { 'App-Type': 'web' }
        })
        if (res?.status == 2){ 
          setIsJobProfileCreated(true)
          return true
        }
        else {
          setIsJobProfileCreated(false)
          return false
        }
      }else{
        return false
      }
    }else{
      return false
    }
  }
  const loginContinueHandler = async () => {
    if (!isOnline) {
      setShowToast(CONNECTION_TOAST)
      return true
    }
    const res = await postMethod({
      url: process.env.NEXT_PUBLIC_BASE_URL_API + OTP_GENERATE_ENDPOINT,
      data: { mobile_no: mobileNumber }
    })
    if (res?.['message'] == 'otp generated') setotpModal(true)
    else return true
    return false
  }

  const handleOtp = (otp) => {
    setOtp(otp)
  }

  const handleOtpClose = () => {
    setotpModal(false)
  }

  const handleMobileNumber = (event) => {
    setMobileNumber(event?.target?.value)
  }

  const handleModalClose = async (isLoggedIn=false) => {
    onClose()
    setChangeNumber(false)
    setMobileNumber('')
    setotpModal(false)
    if(typeof(isLoggedIn)=='object')
    {
      return;
    }
    let status = await checkProfileStatus(isLoggedIn)
    if (!status && isclickedHRCTA && isLoggedIn==true) {
      navigateToPagesInSeeker({ pathName: 'create_profile', as: 'create_profile' })
    }
    else{
      router.push('/jobsFiltering');
    }
  }

  return (
    <LoginContext.Provider
      value={{
        setLoginDetails,
        otp,
        handleOtp,
        loginContinueHandler,
        handleMobileNumber,
        isChangeNumber,
        setChangeNumber,
        handleModalClose,
        handleOtpClose,
        countryCode,
        mobileNumber
      }}
    >
      <FooterModal {...{ isOpen: isOpen, handleModalClose }}>
        {!otpModalOpen ? <LoginOrSignUpModal /> : <OtpModal />}
      </FooterModal>
    </LoginContext.Provider>
  )
}
